import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEventMemberListQueryVariables = Types.Exact<{
  input: Types.GetEventMemberListInput;
}>;

export type GetEventMemberListQuery = {
  __typename?: 'Query';
  getEventMemberList: {
    __typename?: 'GetEventMemberListResponse';
    items: Array<{
      __typename?: 'GetEventMemberList';
      firstName: string;
      lastName: string;
      onSiteStatus?: string | null;
      personUuid: string;
      roleName?: string | null;
      statusName: string;
      uuid: string;
    }>;
    pagination?: {
      __typename?: 'PaginationResponse';
      pageNumber: number;
      pageSize: number;
      total: number;
      totalPage: number;
    } | null;
  };
};

export const GetEventMemberListDocument = gql`
  query GetEventMemberList($input: GetEventMemberListInput!) {
    getEventMemberList(input: $input) {
      items {
        firstName
        lastName
        onSiteStatus
        personUuid
        roleName
        statusName
        uuid
      }
      pagination {
        pageNumber
        pageSize
        total
        totalPage
      }
    }
  }
`;
export function useGetEventMemberListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventMemberListQuery,
    GetEventMemberListQueryVariables
  > &
    (
      | { variables: GetEventMemberListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventMemberListQuery,
    GetEventMemberListQueryVariables
  >(GetEventMemberListDocument, options);
}
export function useGetEventMemberListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventMemberListQuery,
    GetEventMemberListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventMemberListQuery,
    GetEventMemberListQueryVariables
  >(GetEventMemberListDocument, options);
}
export function useGetEventMemberListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventMemberListQuery,
        GetEventMemberListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventMemberListQuery,
    GetEventMemberListQueryVariables
  >(GetEventMemberListDocument, options);
}
export type GetEventMemberListQueryHookResult = ReturnType<
  typeof useGetEventMemberListQuery
>;
export type GetEventMemberListLazyQueryHookResult = ReturnType<
  typeof useGetEventMemberListLazyQuery
>;
export type GetEventMemberListSuspenseQueryHookResult = ReturnType<
  typeof useGetEventMemberListSuspenseQuery
>;
export type GetEventMemberListQueryResult = Apollo.QueryResult<
  GetEventMemberListQuery,
  GetEventMemberListQueryVariables
>;
export function refetchGetEventMemberListQuery(
  variables: GetEventMemberListQueryVariables,
) {
  return { query: GetEventMemberListDocument, variables: variables };
}
